import AlbumSelectStep from './AlbumSelectStep';

export default AlbumSelectStep;
